import { render, staticRenderFns } from "./WatchListButton.vue?vue&type=template&id=f4e5d2d0"
import script from "./WatchListButton.vue?vue&type=script&lang=ts"
export * from "./WatchListButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports